import originJsonp from 'jsonp'
import queryString from 'querystring'
import weui from 'weui.js'

/**
 * jsonp请求方法
 * @param url
 * @param data
 * @param option
 * @returns {Promise<any>}
 */
function jsonp (url, data, option) {
  if (data) {
    url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
  }

  return new Promise((resolve, reject) => {
    let loadinginstace
    if (option.showLoading) {
      loadinginstace = weui.loading('loading')
    }
    originJsonp(url, option, (err, data) => {
      let errorMessage = '加载超时'
      if (loadinginstace) {
        loadinginstace.hide()
      }
      if (!err && data && (parseInt(data.resultCode, 10) === 0 || parseInt(data.status) === 0)) {
        resolve(data)
      } else {
        if (data && data.errorDesc) {
          errorMessage = data.errorDesc
        }
        weui.topTips(errorMessage)
        reject(err)
      }
    })
    //   .catch(function(err) {
    //   debugger
    // })
  })
}

/**
 * 转换请求数据
 * @param data
 * @returns {string}
 */
function param (data) {
  return queryString.stringify(data)
}

export {
  jsonp as default,
  param
}



// WEBPACK FOOTER //
// ./src/common/jsonp.js